import { render, staticRenderFns } from "./mytmpl.vue?vue&type=template&id=de20b1cc&scoped=true"
import script from "./mytmpl.vue?vue&type=script&lang=js"
export * from "./mytmpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de20b1cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de20b1cc')) {
      api.createRecord('de20b1cc', component.options)
    } else {
      api.reload('de20b1cc', component.options)
    }
    module.hot.accept("./mytmpl.vue?vue&type=template&id=de20b1cc&scoped=true", function () {
      api.rerender('de20b1cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/mytmpl.vue"
export default component.exports